import React, { PureComponent } from 'react';
import NavLink from './NavLink';

const FASTACCESS_LOGO = require('../../../res/fast-access.svg');

export default class FastAccessLink extends PureComponent {
  render() {
    const { className, style } = this.props;

    return (
      <NavLink
        className={className}
        style={style}
        href={window.config.FASTACCESS_URL}
        target='_self'
        page={null}
        id="fastAccessLink"
      >
        <img
          alt="fastAccess"
          style={{ height: '100%', ...style }}
          key="fast-access-logo"
          className={'fast-scout-name-logo'}
          src={FASTACCESS_LOGO}/>
      </NavLink>
    );
  }
}